import Emitter from 'mitt'

type Events = {
  getGuidelineCategories: null
  getGuidelineDetail: null
  getNewsBanners: null
  getNewsCategories: null
  getNewsDetail: null
  getJobIntro: null
  getKolList: null
  getSchedule: null
  getMVP: null
  getCategories: null
  getLeaderboard: null
  getVSNews: null
  getResourceOfVideos: null
  getHomeVSVideos: null
  completeOdinFinalLiveTask: null
  OdinFinalLiveTimeUpdate: null
  odinFinalVoteUpdate: null
  languageChange: null
}

const emitter = Emitter<Events>()

/**
 * 订阅事件（用本地语言重新请求接口数据）
 */
export const refetchDataByLocalLang = () => {
  emitter.emit('getGuidelineCategories', null)
  emitter.emit('getGuidelineDetail', null)
  emitter.emit('getNewsBanners', null)
  emitter.emit('getNewsCategories', null)
  emitter.emit('getNewsDetail', null)
  emitter.emit('getJobIntro', null)
  emitter.emit('getKolList', null)
  emitter.emit('getSchedule', null)
  emitter.emit('getMVP', null)
  emitter.emit('getCategories', null)
  emitter.emit('getLeaderboard', null)
  emitter.emit('getVSNews', null)
  emitter.emit('getResourceOfVideos', null)
  emitter.emit('getHomeVSVideos', null)
}
export default emitter
